/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pnk_Edit_Not_AllowedInputs */

const vi_pl_pnk_edit_not_allowed = /** @type {(inputs: Pl_Pnk_Edit_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu này không sửa được (chỉ người tạo mới sửa được phiếu đang chờ duyệt).`)
};

/**

* @param {Pl_Pnk_Edit_Not_AllowedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pnk_edit_not_allowed = /** @type {((inputs?: Pl_Pnk_Edit_Not_AllowedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pnk_Edit_Not_AllowedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pnk_edit_not_allowed(inputs)
});